<template>
    <div ref="newPage" class="info-list">
        <Header/>
        <div class="blank20" style="background:#f0f0f0"/>
        <SingleBanner/>
        <div class="main-page-content contain-left-right" style="position: relative;z-index: 99;">
            <LeftContent :type="type"/>
            <RightContent />
        </div>
        <div class="blank20"/>
        <Footer/>
    </div>
</template>
<script>
import LeftContent from './components/leftListContent';
export default {
    data() {
        return {
            type:1,
        }
    },
    components:{
        LeftContent,
    },
    beforeMount() {
        if(this.$route.query.type){
            this.type = Number(this.$route.query.type);
        }
    },
    mounted() {
        window.scrollTo(0,0);
    },
}
</script>
<style lang="scss" scoped>
.info-list{
    // background: #f0f0f0;
}
.main-page-content{
    background: #fff;
    padding-top:10px;
}
::v-deep img{
    z-index: 1 !important;
}
</style>
